import React, { useEffect, useRef, useState } from 'react';
import styles from './Sillabus.module.css';
import Popped from '../poppedUpWindow/Popped';
import Works from '../recommends/Works';
import ester from "../../images/אסתר תלמידות.png"
import Students from '../recommends/StudentsC';

const NailCourseSyllabus = () => {
  const sectionsRef = useRef([]);
  const [isVisible, setIsVisible] = useState({});
  const [openAccordions, setOpenAccordions] = useState({
    acrylic: false,
    gelLacquer: false,
    regular: false,
    extended: false
  });
  const [isPoppedOpen, setIsPoppedOpen] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.lordicon.com/lordicon.js';
    script.async = true;
    document.body.appendChild(script);

    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(prev => ({
            ...prev,
            [entry.target.dataset.section]: true
          }));
        }
      });
    }, observerOptions);

    sectionsRef.current.forEach(ref => {
      if (ref) observer.observe(ref);
    });

    return () => {
      observer.disconnect();
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const addToRefs = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  const toggleAccordion = (accordion) => {
    setOpenAccordions(prev => ({
      ...prev,
      [accordion]: !prev[accordion]
    }));
  };

  const handleButtonClick = () => {
    setIsPoppedOpen(true);
  };

  const acrylicCourseModules = [
    {
      number: "01",
      title: "יסודות ובטיחות",
      duration: "3-4 שעות",
      topics: [
        "מחלות ציפורניים - התמודדות עם כל יד",
        "חיטוי ועיקור מקצועי",
        "הכנה נכונה של סביבת העבודה, כלים וחומרים",
        "אלרגיה והתמכרות - מה חשוב לדעת"
      ]
    },
    {
      number: "02",
      title: "הכנה מקצועית",
      duration: "3-4 שעות",
      topics: [
        "הסרת כל חומר לפני הבנייה (אקריל, ג'ל, לק ג'ל)",
        "הכנת הציפורן הטבעית - מניקור מיועד לבנייה",
        "טכניקות הכנה ייחודיות",
        "הכנת הבסיס המושלם"
      ]
    },
    {
      number: "03",
      title: "עבודה עם טיפס ואורכים",
      duration: "3-4 שעות",
      topics: [
        "עבודה מקצועית עם טיפס",
        "אורכים XS-5XL - אורכים שונים ומדויקים",
        "אורכי אקסטרים מטורפים",
        "צורות מושלמות בקלות"
      ]
    },
    {
      number: "04",
      title: "טכניקת פיסול באקריל",
      duration: "3-4 שעות",
      topics: [
        "איך לקחת את החומר בצורה נכונה",
        "פיסול ציפורניים במבנות מושלמים",
        "בלי שיופים מיותרים - טכניקה נקייה",
        "השיטה המנצחת של אסתר מטי"
      ]
    },
    {
      number: "05",
      title: "אקסטרים וסיום",
      duration: "3-4 שעות",
      topics: [
        "אקסטרים מטורפים - רמה מתקדמת",
        "שילוב טכניקות ייחודיות",
        "טיפים לעבודה עצמאית",
        "טקס סיום והענקת תעודה"
      ]
    }
  ];

  const gelLacquerCourseModules = [
    {
      number: "01",
      title: "יסודות ובטיחות",
      duration: "4 שעות",
      topics: [
        "מחלות ציפורניים - זיהוי והתמודדות",
        "חיטוי ועיקור מקצועי",
        "שיוף נכון של הציפורן הטבעית למניעת שברים והתקפלות הג'ל",
        "הכנה נכונה לציפורן הטבעית כבסיס להנחת חומר"
      ]
    },
    {
      number: "02",
      title: "טכניקות מניקור מתקדמות",
      duration: "4 שעות",
      topics: [
        "מניקור משורי בטכניקה ייחודית של אסתר מטי",
        "מניקור ידני/משולב צבתית",
        "שיופי צורות מדויקות",
        "עבודה עם בסיסי ג'ל שונים והתאמת הג'ל"
      ]
    },
    {
      number: "03",
      title: "מבנה אנטומי וחיזוק",
      duration: "4 שעות",
      topics: [
        "מבנה אנטומי מושלם",
        "חיזוק, תיקון ועיבוי לוחית הציפורן",
        "בונוס - השלמה של ציפורניים שבורות טכניקה מנצחת",
        "טכניקות לציפורניים טבעיות"
      ]
    },
    {
      number: "04",
      title: "גימור וסיום מקצועי",
      duration: "4 שעות",
      topics: [
        "מריחה מדויקת של צבע ג'ל",
        "טכניקות גימור מושלמות",
        "צילומים ותמונות מקצועיות",
        "טקס סיום והענקת תעודה"
      ]
    }
  ];

  const regularCourseModules = [
    {
      number: "01",
      title: "יסודות ובטיחות",
      duration: "3-4 שעות",
      topics: [
        "מחלות ציפורניים - התמודדות מקצועית",
        "חיטוי ועיקור לפי תקנים בינלאומיים",
        "הכנת סביבת עבודה מושלמת",
        "אלרגיות והמנעות - פרוטוקול בטיחות"
      ]
    },
    {
      number: "02",
      title: "הכנה מקצועית",
      duration: "3-4 שעות",
      topics: [
        "הסרת חומרים קיימים (אקריל/ג'ל/לק)",
        "מניקור מתקדם לבנייה",
        "הכנת הציפורן הטבעית",
        "טכניקות הכנה ייחודיות"
      ]
    },
    {
      number: "03",
      title: "בנייה בטיפס",
      duration: "3-4 שעות",
      topics: [
        "עבודה מקצועית עם טיפס",
        "אורכים XS עד 5XL",
        "צורות מושלמות בקלות",
        "טכניקת לקיחת החומר הנכונה"
      ]
    },
    {
      number: "04",
      title: "עיצובים מתקדמים",
      duration: "3-4 שעות",
      topics: [
        "קישוטים עכשוויים וטרנדים",
        "פרנץ' מדויק ומושלם",
        "שיבוץ אבנים יוקרתי",
        "טכניקת אומברה מקצועית"
      ]
    },
    {
      number: "05",
      title: "אומנות וסיום",
      duration: "3-4 שעות",
      topics: [
        "עבודות מורכבות ואקסטרים",
        "שילוב טכניקות מתקדמות",
        "טיפים לעבודה עצמאית",
        "טקס סיום והענקת תעודה"
      ]
    }
  ];

  const extendedCourseModules = [
    {
      number: "01",
      title: "מניקור לק ג'ל + מבנה אנטומי",
      duration: "4 שעות",
      topics: [
        "מניקור משורי בטכניקה ייחודית של אסתר מטי",
        "מבנה אנטומי מושלם ומדויק",
        "חיזוק ציפורניים טבעיות",
        "תיקון ציפורניים שבורות - טכניקה מנצחת"
      ]
    },
    {
      number: "02",
      title: "יסודות בניית ציפורניים",
      duration: "4 שעות",
      topics: [
        "מחלות ציפורניים והתמודדות מקצועית",
        "חיטוי ועיקור לפי תקנים בינלאומיים",
        "הכנת סביבת עבודה מושלמת",
        "הכנה נכונה של הציפורן לבנייה"
      ]
    },
    {
      number: "03",
      title: "בניית ציפורניים בג'ל - חלק א'",
      duration: "4 שעות",
      topics: [
        "עבודה מקצועית עם טיפס",
        "אורכים XS עד 5XL",
        "מבנה גאומטרי מדויק",
        "צורות מושלמות בקלות"
      ]
    },
    {
      number: "04",
      title: "בניית ציפורניים בג'ל - חלק ב'",
      duration: "4 שעות",
      topics: [
        "תרגול מעמיק על דוגמניות",
        "שכלול הטכניקה",
        "עבודה מהירה ויעילה",
        "תיקון טעויות נפוצות"
      ]
    },
    {
      number: "05",
      title: "בניית ציפורניים באקריל - חלק א'",
      duration: "4 שעות",
      topics: [
        "איך לקחת את החומר בצורה נכונה",
        "פיסול ציפורניים במבנות מושלמים",
        "טכניקה נקייה ללא שיופים מיותרים",
        "השיטה הבלעדית של אסתר מטי"
      ]
    },
    {
      number: "06",
      title: "בניית ציפורניים באקריל - חלק ב'",
      duration: "4 שעות",
      topics: [
        "אקסטרים מטורפים - רמה מתקדמת",
        "עבודה עם אורכים קיצוניים",
        "שילוב טכניקות ייחודיות",
        "תרגול אינטנסיבי"
      ]
    },
    {
      number: "07",
      title: "עיצובים מתקדמים - פרנץ'",
      duration: "4 שעות",
      topics: [
        "ציור פרנץ' מדויק בכמה סגנונות",
        "פרנץ' קלאסי ומודרני",
        "טכניקות לפרנץ' מושלם",
        "תרגול על דוגמניות"
      ]
    },
    {
      number: "08",
      title: "עיצובים מתקדמים - אומברה ואבנים",
      duration: "4 שעות",
      topics: [
        "אומברה קבוע - טכניקה מקצועית",
        "שיבוץ אבנים יוקרתי ברמה גבוהה",
        "שילוב צבעים והרמוניות",
        "יצירת מראה יוקרתי"
      ]
    },
    {
      number: "09",
      title: "קישוטים עכשוויים וטרנדים",
      duration: "4 שעות",
      topics: [
        "טעימה מקישוטים עכשוויים",
        "טרנדים חמים בעולם הציפורניים",
        "טכניקות עיצוב ייחודיות",
        "ידע עיצובי בלעדי"
      ]
    },
    {
      number: "10",
      title: "סיום וליווי מקצועי",
      duration: "4 שעות",
      topics: [
        "שכלול כל הטכניקות שנלמדו",
        "טיפים לעבודה עצמאית מוצלחת",
        "איך לבנות עסק מצליח",
        "טקס סיום והענקת תעודה"
      ]
    }
  ];

  const acrylicBenefits = [
    "שיטה בלעדית כמו בחו״ל",
    "אקסטרים מטורפים",
    "אורכים XS-5XL",
    "פיסול ללא שיופים מיותרים",
    "קבוצות של 3-4 בלבד",
    "תעודת גמר מוכרת"
  ];

  const gelLacquerBenefits = [
    "מתאים גם למתחילות",
    "טכניקה ייחודית של אסתר מטי",
    "מבנה אנטומי מושלם",
    "תיקון ציפורניים שבורות",
    "צילומים מקצועיים",
    "תעודת גמר מוכרת"
  ];

  const benefits = [
    "ערכה מקצועית בשווי 1,500 ₪",
    "קישוטים עכשוויים וטרנדים",
    "ציור פרנץ' מדויק",
    "אומברה ושיבוץ אבנים",
    "תעודת גמר מוכרת",
    "ליווי אישי צמוד"
  ];

  const extendedBenefits = [
    "3 קורסים בקורס אחד - חבילה שלמה!",
    "ערכת עבודה מקצועית מתנה",
    "בונוס בשווי מאות שקלים",
    "קישוטים עכשוויים וטרנדים",
    "ציור פרנץ' בכמה סגנונות בקלי קלות",
    "אומברה קבוע ברמה גבוהה",
    "שיבוץ אבנים יוקרתי",
    "ידע עיצובי בלעדי שלא תלמדי בשום מקום אחר",
    "ליווי אישי צמוד, תמיכה וביטחון לעשייה עצמאית",
    "קבוצה אינטימית - עד 4 משתתפות בלבד",
    "תעודת גמר מוכרת"
  ];

  return (
    <div className={styles.container}>
      <div className={styles.bgGradient}></div>

      {/* Method Section */}
      <section 
        data-section="method"
        ref={addToRefs}
        className={`${styles.section} ${isVisible.method ? styles.visible : ''}`}
      >
        <div className={styles.sectionContainer}>
          <h2 className={styles.sectionTitle}>תחזיקי חזק, ככה נראית הדרך איתי</h2>
          <p className={styles.sectionSubtitle}>
            השיטה הייחודית של אסתר מטי שנלמדת רק על ידה בישראל מחולקת ל-2
          </p>

          <div className={styles.grid2}>
            <div className={styles.card}>
              <h3 className={styles.cardTitle}>למתחילות</h3>
              <p className={styles.cardText}>
                מתאים לנשים ללא ידע מוקדם. תלמדי את המקצוע מהבסיס ועד לרמה מקצועית גבוהה
              </p>
            </div>
            <div className={styles.card}>
              <h3 className={styles.cardTitle}>למקצועיות</h3>
              <p className={styles.cardText}>
                לנשים מקצועיות בתחום שרוצות לשדרג את הטכניקה ולהתייחד בשוק
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Extended Course Accordion - קורס הדגל */}
      <section 
        data-section="extended"
        ref={addToRefs}
        className={`${styles.section} ${isVisible.extended ? styles.visible : ''}`}
      >
        <div className={styles.sectionContainer}>
          <div className={`${styles.accordionWrapper} ${styles.accordionFeatured}`}>
            <button 
              className={styles.accordionHeader}
              onClick={() => toggleAccordion('extended')}
            >
              <div className={styles.accordionHeaderContent}>
                <div className={styles.featuredBadge}>⭐ קורס הדגל ⭐</div>
                <h2 className={styles.accordionTitle}>קורס מורחב – 3 קורסים בקורס אחד!</h2>
                <p className={styles.accordionSubtitle}>להפוך למאסטרית אמיתית בתחום הציפורניים</p>
                <p className={styles.accordionDetails}>10 מפגשים | כל מפגש 4 שעות | 09:00–13:00</p>
                <p className={styles.accordionLocation}>📍 קריית גת | קבוצה אינטימית – עד 4 משתתפות</p>
              </div>
              <div className={`${styles.accordionIcon} ${openAccordions.extended ? styles.accordionIconOpen : ''}`}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </button>

            <div className={`${styles.accordionContent} ${openAccordions.extended ? styles.accordionContentOpen : ''}`}>
              <div className={styles.accordionContentInner}>
                <div className={styles.featuredIntro}>
                  <h3 className={styles.featuredIntroTitle}>מה תלמדי בקורס?</h3>
                  <div className={styles.featuredHighlights}>
                    <div className={styles.featuredHighlight}>✨ מניקור לק ג'ל בשילוב מבנה אנטומי</div>
                    <div className={styles.featuredHighlight}>✨ בניית ציפורניים בג'ל</div>
                    <div className={styles.featuredHighlight}>✨ בניית ציפורניים באקריל</div>
                    <div className={styles.featuredHighlight}>✨ מבנה גאומטרי מדויק</div>
                    <div className={styles.featuredHighlight}>✨ עבודה עם אורכים XS עד 5XL</div>
                    <div className={styles.featuredHighlight}>✨ שיטות עבודה מתקדמות ויעילות</div>
                  </div>
                </div>

                <div className={styles.modulesGrid}>
                  {extendedCourseModules.map((module, index) => (
                    <div key={index} className={styles.moduleCard}>
                      <div className={styles.moduleNumber}>{module.number}</div>
                      <h3 className={styles.moduleTitle}>{module.title}</h3>
                      <div className={styles.moduleDuration}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="12" cy="12" r="9" stroke="#ffffff" strokeWidth="1.5"/>
                          <path d="M12 7V12L15 15" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                        <span>{module.duration}</span>
                      </div>
                      <div className={styles.moduleTopics}>
                        {module.topics.map((topic, idx) => (
                          <div key={idx} className={styles.topic}>
                            <span className={styles.topicDot}>•</span>
                            <span>{topic}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

                <div className={styles.benefitsGrid} style={{ marginTop: '3rem' }}>
                  {extendedBenefits.map((benefit, index) => (
                    <div key={index} className={styles.benefitCard}>
                      <span>{benefit}</span>
                    </div>
                  ))}
                </div>

                <div className={styles.featuredCallout}>
                  <p className={styles.featuredCalloutText}>
                    🌟 זה הרגע שלך להפוך כישרון למקצוע מבוקש! 🌟
                  </p>
                </div>

                <div className={styles.courseButtonWrapper}>
                  <button className={styles.courseButton} onClick={handleButtonClick}>
                    להרשמה לקורס הדגל לחצי כאן
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Acrylic Course Accordion */}
      <section 
        data-section="acrylic"
        ref={addToRefs}
        className={`${styles.section} ${isVisible.acrylic ? styles.visible : ''}`}
      >
        <div className={styles.sectionContainer}>
          <div className={styles.accordionWrapper}>
            <button 
              className={styles.accordionHeader}
              onClick={() => toggleAccordion('acrylic')}
            >
              <div className={styles.accordionHeaderContent}>
                <h2 className={styles.accordionTitle}>קורס בניית ציפורניים באקריל</h2>
                <p className={styles.accordionSubtitle}>5 מפגשים | 9:00-13:00 כל מפגש | בקריית גת</p>
              </div>
              <div className={`${styles.accordionIcon} ${openAccordions.acrylic ? styles.accordionIconOpen : ''}`}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </button>

            <div className={`${styles.accordionContent} ${openAccordions.acrylic ? styles.accordionContentOpen : ''}`}>
              <div className={styles.accordionContentInner}>
                <div className={styles.modulesGrid}>
                  {acrylicCourseModules.map((module, index) => (
                    <div key={index} className={styles.moduleCard}>
                      <div className={styles.moduleNumber}>{module.number}</div>
                      <h3 className={styles.moduleTitle}>{module.title}</h3>
                      <div className={styles.moduleDuration}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="12" cy="12" r="9" stroke="#ffffff" strokeWidth="1.5"/>
                          <path d="M12 7V12L15 15" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                        <span>{module.duration}</span>
                      </div>
                      
                      <div className={styles.moduleTopics}>
                        {module.topics.map((topic, idx) => (
                          <div key={idx} className={styles.topic}>
                            <span className={styles.topicDot}>•</span>
                            <span>{topic}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

                <div className={styles.benefitsGrid} style={{ marginTop: '3rem' }}>
                  {acrylicBenefits.map((benefit, index) => (
                    <div key={index} className={styles.benefitCard}>
                      <span>{benefit}</span>
                    </div>
                  ))}
                </div>

                <div className={styles.courseButtonWrapper}>
                  <button className={styles.courseButton} onClick={handleButtonClick}>
                    להרשמה לקורס לחצי כאן
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gel Lacquer Course Accordion */}
      <section 
        data-section="gel-lacquer"
        ref={addToRefs}
        className={`${styles.section} ${isVisible['gel-lacquer'] ? styles.visible : ''}`}
      >
        <div className={styles.sectionContainer}>
          <div className={styles.accordionWrapper}>
            <button 
              className={styles.accordionHeader}
              onClick={() => toggleAccordion('gelLacquer')}
            >
              <div className={styles.accordionHeaderContent}>
                <h2 className={styles.accordionTitle}>קורס לק ג'ל ומבנה אנטומי</h2>
                <p className={styles.accordionBadge}>הקורס הנחשק ביותר</p>
                <p className={styles.accordionSubtitle}>4 מפגשים | 9:00-13:00 כל מפגש</p>
              </div>
              <div className={`${styles.accordionIcon} ${openAccordions.gelLacquer ? styles.accordionIconOpen : ''}`}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </button>

            <div className={`${styles.accordionContent} ${openAccordions.gelLacquer ? styles.accordionContentOpen : ''}`}>
              <div className={styles.accordionContentInner}>
                <div className={styles.modulesGrid}>
                  {gelLacquerCourseModules.map((module, index) => (
                    <div key={index} className={styles.moduleCard}>
                      <div className={styles.moduleNumber}>{module.number}</div>
                      <h3 className={styles.moduleTitle}>{module.title}</h3>
                      <div className={styles.moduleDuration}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="12" cy="12" r="9" stroke="#ffffff" strokeWidth="1.5"/>
                          <path d="M12 7V12L15 15" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                        <span>{module.duration}</span>
                      </div>
                      <div className={styles.moduleTopics}>
                        {module.topics.map((topic, idx) => (
                          <div key={idx} className={styles.topic}>
                            <span className={styles.topicDot}>•</span>
                            <span>{topic}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

                <div className={styles.benefitsGrid} style={{ marginTop: '3rem' }}>
                  {gelLacquerBenefits.map((benefit, index) => (
                    <div key={index} className={styles.benefitCard}>
                      <span>{benefit}</span>
                    </div>
                  ))}
                </div>

                <div className={styles.courseButtonWrapper}>
                  <button className={styles.courseButton} onClick={handleButtonClick}>
                    להרשמה לקורס לחצי כאן
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Regular Course Accordion */}
      <section 
        data-section="regular"
        ref={addToRefs}
        className={`${styles.section} ${isVisible.regular ? styles.visible : ''}`}
      >
        <div className={styles.sectionContainer}>
          <div className={styles.accordionWrapper}>
            <button 
              className={styles.accordionHeader}
              onClick={() => toggleAccordion('regular')}
            >
              <div className={styles.accordionHeaderContent}>
                <h2 className={styles.accordionTitle}>קורס בניית ציפורניים בג'ל</h2>
                <p className={styles.accordionSubtitle}>5 מפגשים | 3-4 שעות כל מפגש</p>
              </div>
              <div className={`${styles.accordionIcon} ${openAccordions.regular ? styles.accordionIconOpen : ''}`}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </button>

            <div className={`${styles.accordionContent} ${openAccordions.regular ? styles.accordionContentOpen : ''}`}>
              <div className={styles.accordionContentInner}>
                <div className={styles.modulesGrid}>
                  {regularCourseModules.map((module, index) => (
                    <div key={index} className={styles.moduleCard}>
                      <div className={styles.moduleNumber}>{module.number}</div>
                      <h3 className={styles.moduleTitle}>{module.title}</h3>
                      <div className={styles.moduleDuration}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="12" cy="12" r="9" stroke="#ffffff" strokeWidth="1.5"/>
                          <path d="M12 7V12L15 15" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                        <span>{module.duration}</span>
                      </div>
                      <div className={styles.moduleTopics}>
                        {module.topics.map((topic, idx) => (
                          <div key={idx} className={styles.topic}>
                            <span className={styles.topicDot}>•</span>
                            <span>{topic}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

                <div className={styles.benefitsGrid} style={{ marginTop: '3rem' }}>
                  {benefits.map((benefit, index) => (
                    <div key={index} className={styles.benefitCard}>
                      <span>{benefit}</span>
                    </div>
                  ))}
                </div>

                <div className={styles.courseButtonWrapper}>
                  <button className={styles.courseButton} onClick={handleButtonClick}>
                    להרשמה לקורס לחצי כאן
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Summary */}
      <section 
        data-section="benefits"
        ref={addToRefs}
        className={`${styles.section} ${isVisible.benefits ? styles.visible : ''}`}
      >
        <div className={styles.sectionContainer}>
          <h2 className={styles.sectionTitle}>יש קסמים שיש רק כאן</h2>
          <p className={styles.sectionSubtitle}>הצעד הראשון שלך מתחיל עכשיו!</p>
        </div>
      </section>

      {/* CTA */}
      <section 
        data-section="cta"
        ref={addToRefs}
        className={`${styles.section} ${isVisible.cta ? styles.visible : ''}`}
      >
        <div className={styles.sectionContainer}>
          <div className={styles.ctaCard}>
            <h2 className={styles.ctaTitle}>מוכנה להצטרף?</h2>
            <p className={styles.ctaText}>לחצי על הכפתור שנמצא כאן למטה</p>
            <p className={styles.ctaNote}>תשאירי כמה פרטים קטנים ואנחנו מדברות!</p>
            <button className={styles.ctaButton} onClick={handleButtonClick}>להרשמה לקורס לחצי כאן</button>
          </div>
        </div>
      </section>

      {/* Popped Component */}
      {isPoppedOpen && <Popped onClose={() => setIsPoppedOpen(false)} />}
    </div>
  );
};

export default NailCourseSyllabus;